import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Slide, toast, ToastContainer } from "react-toastify";
import allRoutes from "routes/route";
import { MdOutlineClose } from "react-icons/md";

const App: React.FC = () => {
  const routes = createBrowserRouter(allRoutes);
  const successClassName1 = "bg-[#D5F4E5] text-[#143F2A] font-medium w-[22rem] md:w-[27rem] py-2 px-2 my-2  rounded-[4px] absolute flex right-0 border-[1px] border-[#95E3BE] ";
  const errorClassName = "bg-[#FEEFEE] text-[#9C3430] font-medium w-[22rem] md:w-[27rem] py-2 px-2 my-2  rounded-[4px] absolute flex right-0 border-[1px] border-[#E9C7C5] ";
  const warningClassName = "bg-yellow-500 text-white font-medium w-[22rem] md:w-[27rem] py-2 px-2 my-2  rounded-[4px] absolute flex right-0 border border-yellow-600 ";

  return (
    <>
      <RouterProvider router={routes} />;
      <ToastContainer
        transition={Slide}
        hideProgressBar={true}
        icon={false}
        containerId={1}
        bodyStyle={{ height: "2rem" }}
        closeButton={
          <div className="flex items-center text-2xl cursor-pointer">
            <MdOutlineClose onClick={() => toast.dismiss()} />
          </div>
        }
        // eslint-disable-next-line react/prop-types
        toastClassName={(props: any) => (props?.type === "success" ? successClassName1 : props?.type === "warning" ? warningClassName : errorClassName)}
      />
    </>
  );
};

export default App;
